import ApiService from '../apiService';
import { trackEvent } from '@/utils/tracking';

export default {
  // **********************************************************
  //
  // VIRTUAL DEVICE DRIVERS
  //
  // **********************************************************
  async fetch(opts) {
    const params = {
      limit: opts.limit,
      offset: opts.offset,
      sortBy: opts.sortBy,
      sortDesc: opts.sortDesc,
      fields: opts.fields,
      search: opts.search,
      accounts: opts.accountIds,
      paginate: true,
      smartGroupId: opts.smartGroupId,
      usedByAnotherAccount: opts.usedByAnotherAccount,
      limitToAccountOnly: opts.limitToAccountOnly,
      accountId: opts.accountId,
    };
    const response = await ApiService.instance.get('/devicedrivers/list', { params, timeout: 25000 });
    return response.data;
  },

  async fetchOneById(id) {
    const response = await ApiService.instance.get(`/devicedrivers/${id}`);
    return response.data;
  },

  async createOne(data) {
    const allowedKeys = [
      'accountId',
      'title',
      'description',
      'visibility',
      'properties',
      'image',
      'versions',
      'niota_maps',
    ];

    const cleanedData = Object.fromEntries(Object.entries(data).filter(([key]) => allowedKeys.includes(key)));

    const response = await ApiService.instance.post('/devicedrivers', cleanedData);

    trackEvent('devicedrivers', 'createOne');

    return response.data;
  },

  async updateOne(id, data) {
    const allowedKeys = ['title', 'description', 'visibility', 'properties', 'image', 'versions', 'niota_maps'];

    const cleanedData = Object.fromEntries(Object.entries(data).filter(([key]) => allowedKeys.includes(key)));
    const response = await ApiService.instance.put(`/devicedrivers/${id}`, cleanedData);

    trackEvent('devicedrivers', 'updateOne');

    return response.data;
  },

  async deleteOne(id) {
    const response = await ApiService.instance.delete(`/devicedrivers/${id}`);

    trackEvent('devicedrivers', 'deleteOne');

    return response.data;
  },
};
